import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MeetingsPage } from '@/features/siteplan/meetings-page';

const searchSchema = z.object({
  tab: z.enum(['meetings', 'actions', 'escalations']).optional().catch(undefined),
  meeting: z.string().optional().catch(undefined),
  action: z.string().optional().catch(undefined),
  escalation: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/meetings')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <MeetingsPage
      projectId={projectId}
      tab={search.tab}
      meetingId={search.meeting}
      actionId={search.action}
      escalationId={search.escalation}
    />
  );
}
